import { ButtonType } from '@naturehouse/design-system/components/atoms/button/Button';
import type { DefaultComponentType } from '../../../../src/utils/types';
import template from './InlineTextButton.html.njk';

export type InlineTextButtonProps = DefaultComponentType & {
    label: string;
    type?: ButtonType;
};

const InlineTextButtonComponent = (props: InlineTextButtonProps) => template.render(props);

export default InlineTextButtonComponent;
